import { Box, Link, Typography, useTheme } from '@mui/material';
import * as React from 'react';

interface PlacesCardProps {
    placeName: string;
    selectedPlace: string;
    onClick: () => void;
}

const PlacesCard: React.FC<PlacesCardProps> = ({ placeName, onClick, selectedPlace }) => {
    const theme = useTheme();
    const isSelected = selectedPlace === placeName;

    return (
        <Box
            onClick={onClick}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: 2,
                margin: 0.5,
                width: "100%",
                height: "80px",
                borderRadius: 2,
                cursor: 'pointer',
                backgroundColor: isSelected ? theme.palette.primary.light : theme.palette.background.paper,
                color: isSelected ? theme.palette.primary.contrastText : theme.palette.text.primary,
                textOverflow: "ellipsis",
                '&:hover': {
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText
                },
            }}

        >
            <Typography variant='button' sx={{
                width: "150px",
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            }}>
                {placeName}
            </Typography>
            <Link underline="none" onClick={onClick}>
                {' '}
            </Link>
        </Box>
    );
};

export { PlacesCard };
